export default "//yastatic.net/s3/distribution/pythia/frontend/_/93bef2bbada2710fd6555d3aafe70bf1.png";